var styles = {"button":"IconButton-module_button__cQCkO","icon":"IconButton-module_icon__e5JLG","small":"IconButton-module_small__HsxDt","medium":"IconButton-module_medium__spRBr","large":"IconButton-module_large__njDkO","secondary":"IconButton-module_secondary__xPK4p"};

export { styles as default };
